import React from 'react';
import { Box, FormLabel, Stack, SxProps, Theme, Tooltip, Typography } from '@mui/material';
import help from '../../asset/images/icons/es_help_circle.svg';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { useThemeContext } from '../../hook/useThemeManager';
import CustomLazyLoadImage from '../Image/CustomLazyLoadImage';

export interface IToolTip {
    text: string;
    imageStyle?: React.CSSProperties;
    label?: string;
    labelStyle?: React.CSSProperties;
    sx?: SxProps<Theme>;
    textBoxSx?: SxProps<Theme>;
}

const ToolTip: React.FC<IToolTip> = ({ text, imageStyle, label, labelStyle, sx, textBoxSx }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Stack direction="row" alignItems="center" sx={sx} spacing={0.5}>
            {label && (
                <FormLabel
                    sx={{
                        fontSize: 14,
                        fontWeight: 400,
                        color: theme[themeStyle].form_label,
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        ...labelStyle,
                    }}>
                    {label}
                </FormLabel>
            )}

            <Tooltip
                title={
                    <Typography
                        sx={{
                            fontFamily: FONT_ENUM.MAIN_MEDIUM,
                            color: theme[themeStyle].tag_white,
                            fontSize: 12,
                            ...textBoxSx,
                        }}>
                        {text}
                    </Typography>
                }
                placement="top"
                arrow
                componentsProps={{
                    tooltip: {
                        sx: {
                            backgroundColor: theme[themeStyle].deep_grey,
                            borderRadius: 1,
                            p: 1,
                        },
                    },
                }}>
                <Box component="span" sx={{ display: 'inline-flex' }}>
                    <CustomLazyLoadImage
                        src={help}
                        alt="Help"
                        height={20}
                        width={20}
                        style={{ cursor: 'pointer', ...imageStyle }}
                    />
                </Box>
            </Tooltip>
        </Stack>
    );
};

export { ToolTip };
